// @flow

// Polyfill
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// React
import React from 'react'
import ReactDOM from 'react-dom'

// Css
import 'normalize.css'

// Components
import AppContainer from './containers/AppContainer'

// Sagas
import rootSaga from 'data/initializeAppSaga'

// Other
import locale from './locale'
import store, { history } from 'hfty-store/dom'
// import injectTapEventPlugin from 'react-tap-event-plugin'

// Initialize Google Analytics
import ReactGA from 'react-ga'

ReactGA.initialize('UA-60115835-2', {
  gaOptions: {
    siteSpeedSampleRate: 10,
    alwaysSendReferrer: true,
  },
})

function initialize(): { render: Function } {
  // ========================================================
  // Browser History Setup
  // ========================================================
  // const browserHistory = useRouterHistory(createBrowserHistory)({
  //   basename: __BASENAME__,
  // })

  // Internationalization
  locale()

  // ========================================================
  // Render Setup
  // ========================================================
  // injectTapEventPlugin()

  window.__root_container = document.getElementById('root')

  function render() {
    ReactDOM.render(<AppContainer store={store} history={history} />, window.__root_container)
  }

  // This code is excluded from production bundle
  if (__DEV__ && module.hot) {
    module.hot.accept('./containers/AppContainer', function () {
      render()
    })
  }

  if (__DEV__) {
    document.title = 'FE Soils Dev'
  }

  return { render }
}

// ========================================================
// Go!
// ========================================================
const intlPolyfillPromise = self.Intl
  ? Promise.resolve(true)
  : new Promise((resolve: Function) => {
      // $FlowFixMe
      require.ensure(
        [],
        (require: Function) => {
          const result = require('intl')
          resolve(result)
        },
        'intl-polyfill'
      )
    })

const fetchPolyfillPromise = self.fetch
  ? Promise.resolve(true)
  : new Promise((resolve: Function) => {
      // $FlowFixMe
      require.ensure(
        [],
        (require: Function) => {
          const result = require('whatwg-fetch')
          resolve(result)
        },
        'fetch-polyfill'
      )
    })

Promise.all([intlPolyfillPromise, fetchPolyfillPromise]).then((results: any) => {
  const { render } = initialize()

  store.runSaga(rootSaga)
  render()
})
